import { useParams } from 'react-router-dom';

import { useHostProject } from '@/hooks/useSwr.tsx';
import RocketShipIcon from '@/icons/RocketShip.svg?react';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function HostProjectCrumb(props: Partial<BreadcrumbData>) {
  const { hostProjectId } = useParams();
  const project = useHostProject(hostProjectId!);

  return (
    <Breadcrumb
      name={project.data?.name ?? 'Deployment'}
      icon={<RocketShipIcon />}
      {...props}
    />
  );
}
